import { httpClient } from '../../httpClient'

type UpdateIdeaStatusParams = {
  ideaId: string
  statusId: string
}

export const updateIdeaStatus = async ({
  ideaId,
  statusId,
}: UpdateIdeaStatusParams) => {
  const response = await httpClient.post(
    `/ideas/funnel/ideas/${ideaId}/status`,
    {
      statusId,
    },
  )
  return response.data
}
